// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import GetDigitalDonationReceiptFormDefinitionRequestDTO from '../../dto/request/GetDigitalDonationReceiptFormDefinitionRequestDTO';

export default abstract class GetDigitalDonationReceiptFormDefinitionRequestModel extends BaseModel<GetDigitalDonationReceiptFormDefinitionRequestDTO> {
  // #region    ──BodyRequest──────────────────────────╮
  // #endregion ───────────────────────────────────────╯
  // #region    ──HeaderRequest──────────────────────────╮
  // #endregion ─────────────────────────────────────────╯
  // #region    ──QueryRequest──────────────────────────╮
  /**
  */
  get appSystemKey() { return this.dto.appSystemKey; }
  set appSystemKey(value) { this.dto.appSystemKey = value; }
  /**
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get contactId() { return this.dto.contactId; }
  set contactId(value) { this.dto.contactId = value; }
  // #endregion ────────────────────────────────────────╯

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.appSystemKey = qs.appsystemkey;
    this.dto.id = qs.id;
    this.dto.contactId = qs.contactid;
  }
}
